import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

import 'bootstrap/dist/css/bootstrap.min.css'
import './lib/styles/global.scss'

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'
import {
  ErrorPage,
  LandingPage,
  PartnersPage,
  PageNotFound,
  FundPage,
  DaoSubdomain,
  IdSubdomain,
  LabsSubdomain,
  OcxSubdomain,
  MicaWhitepaper,
} from './lib/pages'
// import { MintSubdomain } from './lib/pages/MintSubdomain';
import OcaPage from "./lib/pages/OcaPage";

// staking specific imports
import { StakingMain } from './lib/pages/Staking'
import { HomePage } from './lib/pages/HomePage/HomePage'

const MainAppContainer = () => {

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={ <App /> } errorElement={<ErrorPage />}>
        {/* home page (+ waitlist deep links for QR / campaign URLs) */}
        <Route path="/" element={<HomePage />} />
        <Route path="/protocol" element={<HomePage />} />
        <Route path="/index.html" element={<HomePage />} />
        <Route path="/ai-fast-track-waitlist" element={<HomePage />} />
        <Route path="/open-campus-web-app-waitlist" element={<HomePage />} />

        {/* staking */}
        <Route path="/staking/*" element={ <StakingMain /> }/>

        {/* main website pages */}
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/fund" element={<FundPage />} />

        <Route path="/oc-achievements" element={<OcaPage />} />

        {/* documents */}
        <Route path="/mica-whitepaper" element={<MicaWhitepaper />} />

        {/* subdomains */}
        {/* <Route path="/dao/*" element={<DaoSubdomain />} />
        <Route path="/mint/*" element={<MintSubdomain />} />
        <Route path="/id/*" element={<IdSubdomain />} />
        <Route path="/labs/*" element={<LabsSubdomain />} />
        <Route path="/ocx/*" element={<OcxSubdomain />} /> */}

        {/* 404 */}
        <Route path="/*" element={<PageNotFound />} />
      </Route>,
    ),
  )

  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MainAppContainer />
  </React.StrictMode>,
)
